import { useEffect, memo, Fragment, useContext, useState } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import  {roleTypes} from '../../data/roleType'
//react-shepherd
import { ShepherdTourContext } from "react-shepherd";

// header
import Header from "../../components/partials/dashboard/HeaderStyle/header";

//subheader
import SubHeader from "../../components/partials/dashboard/HeaderStyle/sub-header";

//sidebar
import Sidebar from "../../components/partials/dashboard/SidebarStyle/sidebar";

//footer
import Footer from "../../components/partials/dashboard/FooterStyle/footer";

//seetingoffCanvas
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";

import Loader from "../../components/Loader";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";

// Redux Selector / Action
import { useSelector } from "react-redux";

const Tour = () => {
  const tour = useContext(ShepherdTourContext);
  const { pathname } = useLocation();
  useEffect(() => {
    if (
      pathname === "/dashboard" &&
      sessionStorage.getItem("tour") !== "true"
    ) {
      tour?.start();
    }
  });
  return <Fragment></Fragment>;
};
const Default = memo((props) => {
  const appName = useSelector(SettingSelector.app_name);
  const navigate = useNavigate();
  const token = localStorage.getItem("coyote-token");
  const [decodedToken, setDecodedToken] = useState();

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; 

        if (decoded.exp < currentTime) {
          const isAdmin = decoded?.user?.roles.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          );

          if (isAdmin) {
            localStorage.removeItem("coyote-token");
            setDecodedToken(undefined);

            navigate("/admin/auth/sign-in", {
              state: { status: "expired" },
            });
          } else {
            localStorage.removeItem("coyote-token");
            setDecodedToken(undefined);
            navigate("/user/auth/sign-in", {
              state: { status: "expired" },
            });
          }
        } else {
          setDecodedToken(decoded?.user);
        }
      } catch (error) {
        console.error("Failed to decode token", error);
        localStorage.removeItem("coyote-token");
        navigate("/user/auth/sign-in", {
          state: { status: "invalid-token" },
        });
      }
    } else {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return;
    }
  }, [token, navigate]);
  
  return (
    <Fragment>
      <Loader />
      <Sidebar app_name={appName} />
      <Tour />
      <main className="main-content">
        <div className="position-relative">
          <Header />
          <SubHeader />
        </div>
        <div className="py-0 conatiner-fluid content-inner mt-n5">
          <Outlet />
        </div>
        <Footer />
      </main>
      <SettingOffCanvas />
    </Fragment>
  );
});

Default.displayName = "Default";
export default Default;
